module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "icon": "battery_charging_full",
      "backgroundColor": "#2196f3"
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('mu-badge', {
    attrs: {
      "content": _vm.trainCounts,
      "circle": "",
      "secondary": ""
    }
  }, [_c('span', {
    staticClass: "train-counts"
  }, [_vm._v("训练次数")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-945e94ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timer/allTrainTimes.vue
// module id = 1016
// module chunks = 2